import { getToken } from "services/token.service";
import { GET_MY_DATA } from "endpoints";

const configuration = (window as any).configuration;
const AWS_URL = configuration.awsUrl;

export const fetchMyData = () => {
  return new Promise((resolve, reject) => {
    getToken().then((token) => {
      return fetch(AWS_URL + GET_MY_DATA, {
        headers: {
          "Content-Type": "application/json",
          Authorization: token,
        } as HeadersInit,
        method: "get",
      })
        .then((response) => {
          if (response.ok) {
            resolve(response.json());
          }

          reject(response.status === 401 ? new Error(`Unauthorized`) : new Error(`Error (${response.status})`));
        })
        .catch((error) => console.error(error));
    });
  });
};
